import React, { useEffect } from "react";
import classes from "./Container.module.scss";
import Image from "../sharedUI/Image/Image";
import Header from "../sharedUI/Header/Header";
import { useState } from "react";
import Loader from "../sharedUI/Loader/Loader";
import { useSelector, useDispatch } from "react-redux";
import SystemError from "../sharedUI/Error/SystemError";
// import { RedirectToHelpScreen } from "../../shared/utility";
import { funcHandleGenericError } from "../../store/actions/AppStateActions";
import { detectWebCam } from "../../shared/photo.utility";
import { setWebCamStatus } from "../../store/actions/AppStateActions";
import FatalError from "../Error/FatalError/index";

export const Container = (props) => {
    const dispatch = useDispatch();
    const [isIOS, setIsIOS] = useState(false);
    const [isExitApp, setIsExitApp] = useState(false);
    const isLoading = useSelector((state) => state.PenyDrop.isLoading);
    const currentAppState = useSelector((state) => state.AppState);
    const funcHandleError = (isGenericError, handleClick) => dispatch(funcHandleGenericError(isGenericError, handleClick));

    const childwindowHandler = (e) => {
        if (window && window.childwindow && !window.childwindow.closed) {
            window.childwindow.focus();
            if (e && e.preventDefault && e.stopPropagation) {
                e.preventDefault();
                e.stopPropagation();
            }
        }
    }
    window.addEventListener("focus", childwindowHandler);
    useEffect(() => {
        let iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        setIsIOS(iOS);
        detectWebCam().then((d) => {
            dispatch(setWebCamStatus(d));
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const Exit = () => {
        // currentAppState.exitEvent()
        setIsExitApp(true);
        funcHandleError(false, null)
    }
    return (
        <>
            {/* for pixel to pixel */}
            <div className={classes.testPixel}>
                <Image filename={"01 Global Help"} ext="png" alt="" />
            </div>

            {isLoading && <div onClick={() => childwindowHandler()} className={classes.PopupBox}>
                <div className={classes.Box}>
                    <div className={classes.LoadingContainer}>
                        <Loader />
                    </div>
                </div>
            </div>}
            {
                currentAppState.isGenericError &&
                <div className={classes.PopupBox}>
                    <div className={`${classes.ErrorPopupContainer} ${"backInUpAnimation600ms"}`}>
                        {currentAppState?.retryCount < 4 ?
                            (currentAppState?.appLoader || currentAppState?.loading) ?
                                <div className={classes.Box}>
                                    <div className={classes.LoadingContainer}>
                                        <Loader />
                                    </div>
                                </div> :
                                < SystemError
                                    errorMsg={currentAppState?.errorMessage ? currentAppState?.errorMessage : "Something wrong here. Please try again"}
                                    btnLabel="Try again"
                                    clickEvent={currentAppState?.clickEvent}
                                /> :
                            Exit()
                        }
                    </div>
                </div>
            }
            {isExitApp && <FatalError />}

            {/* for pixel to pixel */}

            <div className={`${classes.FlexContainer} ${isIOS ? classes.iosDevice : ""}`}>
                <Header classes={classes} />
                <>{props.children}</>
            </div>
        </>
    );
}

export default Container;